import {
  Button,
  Tabs,
  Popover,
  Modal,
  Input,
  Form,
  Row,
  Select,
  Col,
  Radio,
  Popconfirm,
  Switch,
  Typography,
} from "antd";
import Assessment from "../../models/Assessment.json";

import React, { useEffect, useState } from "react";
import "../../styles/components.scss";
import { Header } from "../../components/Header";
import { FormattedMessage } from "react-intl";

import { useLocation, useNavigate } from "react-router-dom";
import {
  getListTemplates,
  toDeleteTemplate,
  toUpdateName,
  toUpdateTemplate,
  toCreateTemplate,
} from "../../utils/APIs";

import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import { getLanguage, getTranslatedValue, tagRender } from "../../utils/Utils";
import countries from "../../data/countries.json";
import ScreenLoader from "../../components/ScreenLoader";
import PracticeForm from "../../components/PracticeForm";

const { TabPane } = Tabs;
const { Option } = Select;
const language = getLanguage();

const ManageTemplates = ({ ToolStore }) => {
  const [loading, setLoading] = useState(true);
  const [dso, setDSO] = useState(false);

  const [form] = Form.useForm();
  const location = useLocation();
  const [selected, setSelected] = useState(false);
  const [country, setCountry] = useState(location.state.country);
  const [step, setStep] = useState(1);
  const [activeKey, setActive] = useState(0);
  const [targetKey, setTargetKey] = useState(null);
  const [selectedItem, setSelectedItem] = useState(-1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedChoice, setSelectedChoice] = useState(-1);
  const [selectedId, setSelectedId] = useState(-1);
  const [selectedIds, setSelectedIds] = useState([country.id]);
  const [selectedNames, setSelectedNames] = useState([country.name]);
  const [countryModal, setCountryModal] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [allTemplates, setAllTemplates] = useState([]);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [open, setOpen] = useState(false);
  const [formPractice] = Form.useForm();
  const [formCases] = Form.useForm();
  const navigate = useNavigate();

  const [hideUnhide, setState] = useState({
    increaseLeads: true,
    increaseConversion: true,
    workLess: true,
    noriskTrying: true,

    increaseConversionFrom: true,
    noriskTryingVision: true,

    dmSaves: true,
    workLessmonitoring: true,
    Increaseprofitability: true,
    increaseNumberTreatment: true,
    introduceRetention: true,
    relapseRate: true,
    annualMargin: true,

    workLesssummary: true,
    calculation: true,
    dashboard: true,
    achieveGoals: true,
  });

  useEffect(() => {
    getAllTemplates();
    onChangeSelect([country.name]);
    initializeTemplates(false);
  }, []);
  const initializeTemplates = (dsoValue) => {
    var initialPanes = [];

    ToolStore.setTemplates(initialPanes);
    setSelectedItem(-1);

    ToolStore.setInitialValues(initialPanes[0]);

    setTemplates(initialPanes);
    setActive(0);

    getListTemplates(country.id).then((res) => {
      res.forEach((element) => {
        if (dsoValue == element.dso) {
          initialPanes.push({
            title: element.name,
            content: element.name,
            key: element.id,
            indicators: element.indicators,
            visible: false,

            results: element.results,
          });
        }
      });
      if (initialPanes.length > 0) {
        ToolStore.setTemplates(initialPanes);
        setSelectedItem(initialPanes[0]);

        ToolStore.setInitialValues(initialPanes[0]);
        setState(initialPanes[0].indicators);
        toUpdateForms(initialPanes[0]);
        setTemplates(initialPanes);
        setActive(initialPanes[0].id);
      }

      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
  };
  const getCountryId = (name) => {
    var index = -1;
    if (language == "fr") {
      index = countries.findIndex((a) => a.title_fr == name);
    } else {
      index = countries.findIndex((a) => a.title_en == name);
    }
    return countries[index].id;
  };
  const onChangeSelect = (e) => {
    var l__array = [];
    e.forEach((element) => {
      l__array.push(getCountryId(element));
    });
    setSelectedIds(l__array);
  };

  const onChangeCountry = (e) => {
    var list = [];
    var countryId = getCountryId(e);
    allTemplates.forEach((el) => {
      if (el.countryId == countryId) {
        list.push(el);
      }
    });
    setSelectedTemplates(list);
  };
  const getCountryName = (country) => {
    return language == "fr" ? country.title_fr : country.title_en;
  };

  const getAllTemplates = () => {
    var initialPanes = [];

    getListTemplates(null).then((res) => {
      res.forEach((element) => {
        initialPanes.push({
          title: element.name,
          content: element.name,
          key: element.id,
          indicators: element.indicators,
          countryId: element.country_id,
          visible: false,
          results: element.results,
        });
      });
      setAllTemplates(initialPanes);
    });
  };

  const saveTemplate = () => {
    toUpdateTemplate(
      selectedItem.key,
      selectedItem.results,
      hideUnhide,
      selectedChoice,
      country.id,
      dso
    ).then(() => {
      ToolStore.setInitialValues([]);
      ToolStore.setTemplates([]);
      navigate("/admin");
    });
  };

  const createTemplate = () => {
    toCreateTemplate(
      selectedItem.results,
      hideUnhide,
      selectedChoice,
      selectedIds,
      selectedItem.title,
      dso
    ).then(() => {
      ToolStore.setInitialValues([]);
      ToolStore.setTemplates([]);
      navigate("/admin");
    });
  };

  const toReset = () => {
    setLoading(true);
    var initial = { ...toJS(ToolStore.initialValues) };
    setSelectedItem(initial);
    setLoading(false);
  };
  const toValidate = () => {
    setLoading(true);
    setOpen(false);
    const l__step = step;

    var selected = allTemplates.find((i) => i.key == selectedId);
    var l__selectedItem = { ...selectedItem };

    l__selectedItem.results = selected.results;

    var l__templates = [...templates];

    l__templates.forEach((element) => {
      if (element.key == l__selectedItem.key) {
        element.results = selected.results;
      }
    });

    setStep(-1);
    setTemplates(l__templates);
    ToolStore.setTemplates(l__templates);
    setSelectedItem(l__selectedItem);

    setTimeout(() => {
      setStep(l__step);
      setLoading(false);
    }, 1500);
  };
  const onChange = (activeKey) => {
    setSelectedItem(templates.find((i) => i.key == activeKey));

    ToolStore.setInitialValues(templates.find((i) => i.key == activeKey));
    setState(templates.find((i) => i.key == activeKey).indicators);
    setActive(activeKey);
  };
  const content = (
    <div>
      <span className="roi--popup-text" onClick={(e) => rename(e)}>
        <FormattedMessage id="rename" />
      </span>
      <hr className="roi--hr"></hr>
      <Popconfirm
        title={getTranslatedValue("deleteTemplate")}
        onConfirm={() => toDelete()}
        okText={getTranslatedValue("yes")}
        cancelText={getTranslatedValue("no")}
        placement="left"
      >
        <span className="roi--popup-text">
          <FormattedMessage id="delete" />
        </span>
      </Popconfirm>
      <hr className="roi--hr"></hr>
      <span className="roi--popup-text" onClick={(e) => toDuplicateTemplate(e)}>
        <FormattedMessage id="duplicate" />
      </span>
    </div>
  );

  const toDelete = () => {
    setLoading(true);
    var l__step = step;
    setStep(-1);
    if (targetKey == -1) {
      var initialPanes = templates.filter((a) => a.key != targetKey);
      if (targetKey == selectedItem.key) {
        ToolStore.setTemplates(initialPanes);
        setSelectedItem(initialPanes[0]);

        ToolStore.setInitialValues(initialPanes[0]);
        setState(initialPanes[0].indicators);
        toUpdateForms(initialPanes[0]);
        setActive(initialPanes[0].id);
      }
      setTemplates(initialPanes);

      setTimeout(() => {
        setStep(l__step);

        setLoading(false);
      }, 500);

      return;
    }

    toDeleteTemplate(targetKey).then(() => {
      if (templates.length == 1) {
        navigate("/admin");
      } else {
        var initialPanes = templates.filter((a) => a.key != targetKey);
        if (targetKey == selectedItem.key) {
          setSelectedItem(initialPanes[0]);

          ToolStore.setInitialValues(initialPanes[0]);
          setState(initialPanes[0].indicators);
          toUpdateForms(initialPanes[0]);
          setActive(initialPanes[0].key);
        }
        setTemplates(initialPanes);
        ToolStore.setTemplates(initialPanes);

        setTimeout(() => {
          setStep(l__step);

          setLoading(false);
        }, 500);
      }
    });
  };
  const rename = (e) => {
    e.preventDefault();
    form.setFieldsValue({
      name: templates.find((i) => i.key == targetKey).title,
    });
    var initialPanes = [...templates];
    initialPanes.forEach((element) => {
      element.visible = false;
    });
    setTemplates(initialPanes);
    setIsModalVisible(true);
  };

  const onEdit = (key, action) => {
    if (action == "add") {
      toAddTemplate();
      return;
    }
    const itemIndex = templates.findIndex((a) => a.key == key);
    var initialPanes = [...templates];
    if (targetKey != null) {
      initialPanes.forEach((element) => {
        element.visible = false;
      });
    }
    if (itemIndex != -1 && key != targetKey) {
      setTargetKey(key);

      initialPanes[itemIndex].visible = true;
      toUpdateForms(initialPanes[itemIndex]);
      setTemplates(initialPanes);
    }
  };

  const onYesClick = () => {
    form.validateFields().then(() => {
      if (targetKey == -1) {
        const itemIndex = templates.findIndex((a) => a.key == targetKey);

        var initialPanes = [...templates];
        initialPanes[itemIndex].title = form.getFieldValue("name");
        setTemplates(initialPanes);
        setIsModalVisible(false);
        setTargetKey(null);
      } else {
        toUpdateName(targetKey, form.getFieldValue("name")).then(() => {
          const itemIndex = templates.findIndex((a) => a.key == targetKey);

          var initialPanes = [...templates];
          initialPanes[itemIndex].title = form.getFieldValue("name");
          setTemplates(initialPanes);
          setIsModalVisible(false);
          setTargetKey(null);
        });
      }
    });
  };

  const hidePopup = () => {
    var initialPanes = [...templates];
    if (targetKey != null) {
      initialPanes.forEach((element) => {
        element.visible = false;
      });
      setTemplates(initialPanes);
      setTargetKey(null);
    }
  };

  const toUpdateForms = (element) => {
    formPractice.setFieldsValue({
      openDays: element.openDays,
      speciality: element.speciality,
      separateTeensAdults: element.separateTeensAdults,
    });
    formCases.setFieldsValue({
      newAlignersTreatement: "500",
      addFeeAligners: "50",
      averagePrice: "50",
    });
  };

  const modalConfirm = (
    <Modal
      footer={null}
      style={{ top: 100 }}
      width={"80vh"}
      open={isModalVisible}
      onCancel={() => {
        setIsModalVisible(false);
        setTargetKey(null);
      }}
    >
      <div style={{ marginTop: "4vh", textAlign: "center" }}>
        <span className="roi--text-popup">
          <Form form={form}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              label={<FormattedMessage id="name" />}
              name="name"
            >
              <Input />
            </Form.Item>
          </Form>
        </span>
        <Button
          className="roi--button-primary"
          onClick={() => onYesClick()}
          style={{
            minHeight: "5vh",
            width: "30vh",
            marginTop: "2vh",
            textAlign: "center",
          }}
        >
          <FormattedMessage id="yes" />
        </Button>
      </div>
    </Modal>
  );

  const updateHiding = (values) => {
    setState(values);
  };

  const onSelectTemplate = (id) => {
    setSelectedId(id);
  };

  const toAddTemplate = () => {
    setLoading(true);
    const l__step = step;

    var l__templates = [...templates];
    const l__assement = { ...Assessment };
    var results = l__assement;
    var item = {
      title: "New form",
      content: "New form",
      key: -1,

      visible: false,
      results: results,
    };

    l__templates.push(item);
    setStep(-1);
    setTemplates(l__templates);
    ToolStore.setTemplates(l__templates);
    setSelectedItem(item);

    setTimeout(() => {
      setActive("-1");
      setStep(l__step);
      setLoading(false);
    }, 1500);
  };

  const toDuplicateTemplate = (e) => {
    e.preventDefault();
    setLoading(true);
    const l__step = step;

    var l__templates = [...templates];

    var old_item = l__templates.find((i) => i.key == targetKey);
    var item = { ...old_item };
    item.title = "duplicated_" + item.title;
    item.content = "duplicated_" + item.content;
    item.key = -1;
    item.visible = false;

    l__templates.push(item);
    setStep(-1);
    setTemplates(l__templates);
    ToolStore.setTemplates(l__templates);
    setSelectedItem(item);

    setTimeout(() => {
      setActive("-1");
      setStep(l__step);
      setLoading(false);
    }, 1500);
  };

  return (
    <>
      <div onClick={() => hidePopup()}>
        <Header step={step} updateStep={() => setStep(step - 1)} />
        {loading ? (
          <ScreenLoader />
        ) : (
          <>
            <div style={{ textAlign: "center", marginTop: "10vh" }}>
              <Typography.Title level={2} className="roi--title-admin">
                {country.name + " - "}{" "}
                <FormattedMessage id="manageTheTemplates" />{" "}
              </Typography.Title>
            </div>

            {templates.length > 0 && (
              <Row justify="end" style={{ marginBottom: "2vh" }}>
                <div style={{ display: "flex" }}>
                  {selectedItem.key != -1 && (
                    <Button
                      className="roi--button-template"
                      style={{ marginRight: "1vh" }}
                      onClick={() => toReset()}
                    >
                      <FormattedMessage id="reset" />
                    </Button>
                  )}
                  <Button
                    className="roi--button-template"
                    onClick={() => setOpen(true)}
                  >
                    <FormattedMessage
                      id="useSetting"
                      values={{ roi__br: <br /> }}
                    />
                  </Button>
                </div>
              </Row>
            )}

            {
              <Tabs
                type="editable-card"
                onChange={onChange}
                onEdit={onEdit}
                addIcon={
                  <Row className="roi--template-add">
                    <Col span="4">
                      <img src="/images/icons/plus.png" />
                    </Col>
                    <Col span="20">
                      <span className="roi--title-form">
                        <FormattedMessage id="createNewForm" />
                      </span>
                    </Col>
                  </Row>
                }
                activeKey={activeKey}
              >
                {templates.map((pane) => (
                  <TabPane
                    className="roi--tab"
                    tab={pane.title}
                    key={pane.key}
                    closable={pane.closable}
                    closeIcon={
                      <Popover
                        placement="bottomLeft"
                        content={content}
                        open={pane.visible && !isModalVisible}
                        trigger="click"
                      >
                        <img src="/images/icons/down.svg" />
                      </Popover>
                    }
                  >
                    <PracticeForm
                      action={
                        <div style={{ textAlign: "center" }}>
                          <Button
                            className="roi--button-primary"
                            style={{
                              marginTop: "4vh",
                              textAlign: "center",
                              marginBottom: "2vh",
                            }}
                            onClick={() =>
                              selectedItem.key == -1
                                ? setCountryModal(true)
                                : saveTemplate()
                            }
                          >
                            <FormattedMessage id={"save"} />
                          </Button>
                        </div>
                      }
                      showBtns={false}
                      selected={selectedItem}
                    />
                  </TabPane>
                ))}
              </Tabs>
            }

            <Modal
              open={open}
              width="60vh"
              title={
                <span
                  style={{ textAlign: "center" }}
                  className="roi--summary-big-title"
                >
                  {" "}
                  <FormattedMessage id="useSetting" values={{ roi__br: "" }} />
                </span>
              }
              onCancel={() => setOpen(false)}
              footer={
                <div style={{ textAlign: "center" }}>
                  <Button
                    className="roi--button-primary"
                    style={{
                      textAlign: "center",
                      width: "150px",
                    }}
                    disabled={selectedId == -1}
                    onClick={() => toValidate()}
                  >
                    <FormattedMessage id="validate" />
                  </Button>
                </div>
              }
            >
              <Row>
                <Col
                  span="8"
                  className="roi--summary-big-title"
                  style={{ fontSize: "24px" }}
                >
                  <FormattedMessage id="country" />
                </Col>
                <Col span="16">
                  <Select
                    onChange={(e) => onChangeCountry(e)}
                    tagRender={tagRender}
                    style={{ width: "100%" }}
                    showSearch
                  >
                    {countries.map((country) => (
                      <Select.Option
                        value={
                          language == "fr" ? country.title_fr : country.title_en
                        }
                      >
                        {getCountryName(country)}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
              <Row style={{ marginTop: "2vh" }}>
                <Col
                  span="8"
                  className="roi--summary-big-title"
                  style={{ fontSize: "24px" }}
                >
                  <FormattedMessage id="template" />
                </Col>
                <Col span="16">
                  <Select
                    showSearch
                    style={{ width: "100%" }}
                    onChange={(e) => onSelectTemplate(e)}
                  >
                    {selectedTemplates.map((el, x) => (
                      <Select.Option value={el.key}>{el.title}</Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Modal>

            <Modal
              open={countryModal}
              footer={null}
              width="60vh"
              title={
                <span
                  style={{ textAlign: "center" }}
                  className="roi--summary-big-title"
                >
                  {getTranslatedValue("saveTemplate")}
                </span>
              }
              onCancel={() => setCountryModal(false)}
            >
              <Row
                gutter={24}
                style={{
                  marginRight: "1vh",
                  marginLeft: "2vh",
                }}
              >
                <Col md={1} sm={1} style={{ textAlign: "center" }}>
                  <Radio
                    value={0}
                    checked={selected == 0}
                    onChange={() => {
                      setSelected(0);
                    }}
                  ></Radio>
                </Col>
                <Col md={22} sm={22}>
                  <span
                    className="roi--label-select"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setSelected(0);
                    }}
                  >
                    <FormattedMessage id="onlyFor" />
                    {' "' + country.name + '"'}
                  </span>
                </Col>
              </Row>
              <Row gutter={24} style={{ marginTop: "3vh", marginLeft: "2vh" }}>
                <Col md={1} sm={1} style={{ textAlign: "center" }}>
                  <Radio
                    value={1}
                    checked={selected == 1}
                    onChange={() => {
                      setSelected(1);
                    }}
                  ></Radio>
                </Col>
                <Col md={22} sm={22}>
                  <span
                    style={{ cursor: "pointer" }}
                    className="roi--label-select"
                    onClick={() => {
                      setSelected(1);
                    }}
                  >
                    <FormattedMessage id="forSeveral" />
                  </span>
                </Col>
              </Row>
              {selected == 1 && (
                <>
                  <Row style={{ marginLeft: "6vh", marginTop: "2vh" }}>
                    <span className="roi--label-select">
                      <FormattedMessage id="selectCountries" />
                    </span>
                  </Row>
                  <Row style={{ marginLeft: "6vh", marginTop: "2vh" }}>
                    <Select
                      mode="multiple"
                      showArrow={false}
                      onChange={(e) => onChangeSelect(e)}
                      defaultValue={selectedNames}
                      tagRender={tagRender}
                      style={{ width: "100%" }}
                    >
                      {countries.map((country) => (
                        <Select.Option
                          value={
                            language == "fr"
                              ? country.title_fr
                              : country.title_en
                          }
                        >
                          {getCountryName(country)}
                        </Select.Option>
                      ))}
                    </Select>
                  </Row>
                </>
              )}
              <div style={{ textAlign: "center" }}>
                <Button
                  className="roi--button-primary"
                  style={{
                    marginTop: "4vh",
                    textAlign: "center",
                    marginBottom: "2vh",
                  }}
                  onClick={() => createTemplate()}
                >
                  <FormattedMessage id="save" />
                </Button>
              </div>
            </Modal>
          </>
        )}
      </div>
      {modalConfirm}
    </>
  );
};

export default inject("ToolStore")(observer(ManageTemplates));
